import axios from "axios";
import httpClient from "../../../shared/api/httpClient";

// Rotas de auth públicas (signup/login/verify/reset/resend) não devem levar o
// interceptor de token do httpClient autenticado — usam uma instância própria, mas
// ainda lendo a mesma baseURL via env.
const publicClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://localhost:8080",
  headers: { "Content-Type": "application/json" },
});

// Navegação de página inteira (não AJAX): o fluxo OAuth do Google roda no backend. Leva
// ?challenge=... (ver lib/googleVerifier).
export const GOOGLE_LOGIN_URL = `${publicClient.defaults.baseURL}/api/v1/auth/google/login`;

// O backend responde sempre com o envelope { status, mensagem, dados } — todas as
// funções abaixo já devolvem o `dados` desembrulhado.
export const authApi = {
  signup: ({ email, password, nomeCompleto, acceptTerms }) =>
    publicClient
      .post("/api/v1/auth/signup", { email, password, nome_completo: nomeCompleto, accept_terms: acceptTerms })
      .then((r) => r.data.dados),

  login: ({ email, password }) =>
    publicClient.post("/api/v1/auth/login", { email, password }).then((r) => r.data.dados),

  verifyEmail: (token) =>
    publicClient.get(`/api/v1/auth/verify-email?token=${encodeURIComponent(token)}`).then((r) => r.data.dados),

  resendVerification: (email) =>
    publicClient.post("/api/v1/auth/resend-verification", { email }).then((r) => r.data.dados),

  requestPasswordReset: (email) =>
    publicClient.post("/api/v1/auth/password-reset", { email }).then((r) => r.data.dados),

  confirmPasswordReset: ({ token, newPassword }) =>
    publicClient
      .post("/api/v1/auth/password-reset/confirm", { token, new_password: newPassword })
      .then((r) => r.data.dados),

  // "Entrar com Google": quais logins sociais estão configurados no backend, e a troca do
  // código de uso único (recebido em /auth/google?code=...) pela sessão.
  providers: () => publicClient.get("/api/v1/auth/providers").then((r) => r.data.dados),

  // `verifier` é o valor guardado no sessionStorage ao clicar em "Continuar com Google"
  // (lib/googleVerifier): o código só vale no navegador que iniciou o fluxo.
  googleExchange: (code, verifier) =>
    publicClient
      .post("/api/v1/auth/google/exchange", { code, verifier })
      .then((r) => r.data.dados),

  // Completa o vínculo pendente (conta existente cujo e-mail não é Gmail/Workspace) logo
  // depois do login com senha — autenticado.
  googleConfirmLink: (code, verifier) =>
    httpClient.post("/api/v1/auth/google/link", { code, verifier }).then((r) => r.data.dados),

  logout: () => httpClient.post("/api/v1/auth/logout").then((r) => r.data.dados),

  me: () => httpClient.get("/api/v1/me").then((r) => r.data.dados),

  updatePerfil: (perfil) => httpClient.patch("/api/v1/me/perfil", perfil).then((r) => r.data.dados),
};
